<div class="modal-wrapper">
    <div class="modal-header">
        <h4 class="modal-title">
            <i class="fas fa-exclamation-circle text-warning"></i> Erm...
        </h4>
        <button type="button" class="close" aria-label="Close" (click)="navigateAway(false)">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div><p>You have not saved your changes on this page.</p> <p>If you continue you may lose your work. Are you sure you want to do that?</p></div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="navigateAway(false)">No, take me back</button>
        <button type="button" class="btn btn-primary" (click)="navigateAway(true)">Yes, I don't care</button>
    </div>
</div>
